class CMSAnalytics {
	static load() {
		//@ts-ignore
		window.onFormSuccess = function (response, form) {
			let action = form.action;
			try {
				let actionParts = new URL(action);
				gtag &&
					//@ts-ignore
					gtag("event", "generate_lead", {
						event_label: actionParts.pathname + "/thankyou",
						event_category: "conversion",
					}); 
			} catch (err) {
				gtag &&
					//@ts-ignore
					gtag("event", "generate_lead", {
						event_label: action.replace(window.location.origin) + "/thankyou",
						event_category: "conversion",
					});
			}
		};
		//@ts-ignore
		window.onFormFail = function (response, form) {
            let action = form.action;
			gtag && //@ts-ignore
				gtag("event", "generate_lead_error", {
					event_label: action.replace(window.location.origin),
					event_category: "conversion-error",
				});
		};
	}
}

CMSAnalytics.load();
